module.exports = __webpack_public_path__ + "media/navi/photo_keyflow_2-57c5f911.png";